import React from 'react'
import { MdModeEditOutline } from 'react-icons/md'
import { InstagramEmbed, XEmbed, YouTubeEmbed } from 'react-social-media-embed'

function VideoGallerysDisplay(props) {
  const { GalleryVideos, dragEnter, dragStart, drop, removeVideo, disableInput, EditVideo } = props
  return (
    <>
      {GalleryVideos && GalleryVideos.length !== 0 && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          className='rounded'
        >
          {GalleryVideos.map((item, index) => (
            <div
              onDragStart={e => dragStart(e, index)}
              onDragEnter={e => dragEnter(e, index)}
              onDragEnd={drop}
              draggable
              style={{ display: 'flex' }}
              key={index}
            >
              <div
                className='m-2 rounded'
                style={{ position: 'relative', border: '1px solid lightgray' }}
              >
                {/* show video */}
                <div
                  className='video-container'
                  style={{
                    width: '450px',
                    height: '100%',
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column', // Changed from 'center' to 'column'
                  }}
                >
                  <div style={{ flex: 1 }}>
                    {item.videoPlatform === 'X' && item.path && (
                      <XEmbed url={item.path} width={325} height={220} />
                    )}
                    {item.videoPlatform === 'youtube' && item.path && (
                      <YouTubeEmbed url={item.path} width={325} height={220} />
                    )}
                    {item.videoPlatform === 'instagram' && item.path && (
                      <InstagramEmbed url={item.path} width={325} height={220} />
                    )}
                  </div>
                  <div>
                    {item.title && <div>Title: {item.title}</div>}{' '}
                    {/* Updated 'Tittle' to 'Title' */}
                    {item.galleryTags && item.galleryTags.length >= 1 && (
                      <div>Category: {item.galleryTags.toString()}</div>
                    )}
                  </div>
                  <div style={{ alignSelf: 'flex-end' }}>
                    <button
                      className='removeVideo'
                      type='button'
                      onClick={() => removeVideo(index)}
                    >
                      X
                    </button>
                    <button
                      className='editVideo'
                      type='button'
                      onClick={() => EditVideo(index)}
                      disabled={disableInput === true}
                    >
                      <MdModeEditOutline />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default VideoGallerysDisplay
